'use strict';

var React = require('react');

var SvgTransactionMajor = function SvgTransactionMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m11.293 8.293 1.293-1.293h-9.586v11a1 1 0 1 1-2 0v-16a1 1 0 0 1 2 0v3h9.586l-1.293-1.293a1 1 0 0 1 1.414-1.414l2.999 2.999a1 1 0 0 1 0 1.416l-2.999 2.999a.998.998 0 0 1-1.707-.707 1 1 0 0 1 .293-.707zm6.707-7.293a1 1 0 0 1 1 1v16a1 1 0 0 1-2 0v-3h-9.586l1.293 1.293a1 1 0 1 1-1.414 1.414l-2.999-2.999a1 1 0 0 1 0-1.416l2.999-2.999a1 1 0 0 1 1.414 1.414l-1.293 1.293h9.586v-11a1 1 0 0 1 1-1z"
  }));
};

exports.SvgTransactionMajor = SvgTransactionMajor;
